export default __webpack_public_path__ + "static/kv-banner-lt-en-9041200bce035e9041019c32c7d7804c.png";